import { CreditCard } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { formatWithThousandSeparator } from '@/utils';
import { SectionHeader } from './SectionHeader';
import { SummaryRow } from './SummaryRow';

interface PaymentSummarySectionProps {
  paymentMethod: string;
  orderFee: string;
  shippingFee: string;
  customerPays: number;
  currency: string;
}

export function PaymentSummarySection({
  paymentMethod,
  orderFee,
  shippingFee,
  customerPays,
  currency,
}: PaymentSummarySectionProps) {
  const { t } = useTranslation();

  return (
    <div className="rounded-2xl border border-sd-border bg-sd-card p-5">
      <SectionHeader icon={CreditCard} title={String(t('payment_summary'))} />

      <div className="divide-y divide-sd-border">
        <SummaryRow label={String(t('method'))} value={paymentMethod} />
        <SummaryRow label={String(t('order_fee'))} value={orderFee} />
        <SummaryRow label={String(t('shipping_fee_label'))} value={shippingFee} />

        <div className="flex items-center justify-between py-2.5">
          <span className="text-sm font-semibold">{String(t('customer_pays'))}</span>
          <span className="text-sm font-bold shrink-0">
            {formatWithThousandSeparator(customerPays)} {currency}
          </span>
        </div>
      </div>
    </div>
  );
}
